import React, { useContext, useState } from 'react';
import { StyleContext } from "../../providers/StyleContextProvider";
import { AuthContext } from "../../providers/AuthContextProvider";
import { ProfileEntrance } from "../../components/Home/ProfileEntrance";
import { LoggedRecruiter } from '../../models/LoggedRecruiter';
import { ReactComponent as Search } from '../../assets/svg/search.svg';

interface Props {
    searchEnable: boolean;
    placeholder: string;
    handleSearchSubmit?: (searchTerm: string) => void;
}

export const RecruiterProfileArea: React.FC<Props> = ({searchEnable, placeholder, handleSearchSubmit}) => {
    const styleContext = useContext(StyleContext);
    const authContext = useContext(AuthContext);
    const [styles, setStyles] = useState<any>(styleContext.getComponentStyle("recruiterProfileArea"));
    const recruiter: LoggedRecruiter | null = authContext.getLoggedRecruiter();
    const [searchTerm, setSearchTerm] = useState<string>("");

    return (
        <div style={styles.searchWrapper}>
            {searchEnable && <div style={styles.searchBar}>
                <input style={styles.searchBar.input} placeholder={placeholder} value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} onKeyDown={(e) => e.key === 'Enter' &&  handleSearchSubmit ? handleSearchSubmit(searchTerm) : null}/>
                <Search style={styles.searchBar.icon} onClick={() => handleSearchSubmit ? handleSearchSubmit(searchTerm) : null}/>
            </div>}
            <ProfileEntrance recruiter={recruiter} />
        </div>
    )
}
